// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTableMobileSort-Header_cls1__-udNB","cls2":"VeloTableMobileSort-Header_cls2__wm-tz VeloTableMobileSort-Header_cls1__-udNB"};